import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Aboutanimal() {
  return (
    <section className="about-animal schology-glance p-100">
      <div className="img-right-purple">
        <StaticImage
          src="../../../images/case-studies/schology/ellipse-purple.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={593}
          height={913}
        />
      </div>

      <div className="img-right-green">
        <StaticImage
          src="../../../images/case-studies/schology/ellipse-green.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={612}
          height={932}
        />
      </div>
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#111322" }}>
              Schology at a <span className="purple-box">Glance</span>
            </h2>
            <h3 style={{ color: "#111322" }}>
              Transforming education through a digital ecosystem
            </h3>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center  mb-4 mb-md-5"
          >
            <StaticImage
              src="../../../images/case-studies/schology/glance-1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mb-4 mb-md-5"
          >
            <StaticImage
              src="../../../images/case-studies/schology/glance-2.webp"
              alt="TekRevol"
              className="mt-0 mt-md-5"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mb-4 mb-md-5"
          >
            <StaticImage
              src="../../../images/case-studies/schology/glance-3.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mb-4 mb-md-5"
          >
            <StaticImage
              src="../../../images/case-studies/schology/glance-4.webp"
              alt="TekRevol"
              className="mt-0 mt-md-5"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mb-4 mb-md-0"
          >
            <StaticImage
              src="../../../images/case-studies/schology/glance-5.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
            <StaticImage
              src="../../../images/case-studies/schology/glance-6.webp"
              alt="TekRevol"
              className="mt-0 mt-md-5"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={560}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Aboutanimal;
